import { createKeySelector, createDynamicKeySelector } from 'state/common/selectorFactories';

import { EMPTY_OBJECT } from 'config/constants';

import type { Season } from 'types/shows';

export const getSeasonData = (state: any) => state.seasons || {};
export const getSeasonMap = createKeySelector(getSeasonData, 'byId', EMPTY_OBJECT);
export const getSeasonById = createDynamicKeySelector<Season | undefined | null, string>(getSeasonMap, null);
